import {
  ElasticSearchResponse,
  Promotion,
  PromotionBanner,
  PromotionContenuPromo,
  PromotionDocument,
} from '@shared/services/elastic-search/models';

export const promotionsSerializer = (response: ElasticSearchResponse<PromotionDocument>): Promotion => {
  const promotion = response.hits.hits[0]?._source;
  if (!promotion) return {} as Promotion;
  const contenuPromo = promotion.contenu_promo?.[0];
  const banner = promotion.banner?.[0];
  const heroSliderPromo = promotion.hero_slider_promo?.[0] ?? null!;
  const start = promotion.date_start?.[0];
  const end = promotion.date_end?.[0];
  return {
    contenuPromo: contenuPromo ? (JSON.parse(contenuPromo) as PromotionContenuPromo) : null!,
    banner: banner ? (JSON.parse(banner) as PromotionBanner) : null!,
    heroSliderPromo,
    dateStart: start ? start * 1000 : undefined,
    // The index ends the last day at 23:59:59: one more second gives the exclusive end the banner compares against.
    dateEnd: end ? (end + 1) * 1000 : undefined,
  };
};
